import { ComponentType } from 'react';
import { connect } from 'react-redux';
import { Props } from './DuperbrowsePageWrapper';
import {
  getIsDuperbrowseActive,
  getCurrentItem,
  getIsLoading,
  getLastViewedItem,
} from '../redux/selectors';
import { exitDuperbrowse } from '../redux/actionCreators';
import {
  getIsLoggedIn,
  getIsMobile,
} from '../../publicSession/selectors';
import { getEnabledFlagsList } from '@wix/da-react-context/pkg/flags/redux/selectors';

export type StateProps = Pick<
  Props,
  | 'isDuperbrowseActive'
  | 'currentItem'
  | 'isLoading'
  | 'justClosedAStream'
  | 'isLoggedIn'
  | 'isMobile'
  | 'mobileJoinBannerEnabled'
>;
export type DispatchProps = Pick<Props, 'exitDuperbrowse'>;
export type OwnProps = Omit<Props, keyof (StateProps & DispatchProps)>;

const mapStateToProps = (state): StateProps => ({
  isDuperbrowseActive: getIsDuperbrowseActive(state),
  currentItem: getCurrentItem(state),
  isLoading: getIsLoading(state),
  justClosedAStream: !!getLastViewedItem(state),
  isLoggedIn: getIsLoggedIn(state),
  isMobile: getIsMobile(state),
  mobileJoinBannerEnabled: getEnabledFlagsList(state).includes(
    'mobile_join_banner'
  ),
});

const mapDispatchToProps: DispatchProps = {
  exitDuperbrowse,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
) as (component: ComponentType<Props>) => ComponentType<OwnProps>;
